import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const Share = dynamic(() => import('./Share'));

const ShareConfig = {
  name: 'Share',
};

Builder.registerComponent(Share, ShareConfig);
